import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 19 19"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M16 7v6h-2.25M4 10.75V7m1.5-4.5C5.5 1.675 6.175 1 7 1c2.25 0 3 3 3 3H7c-.825 0-1.5-.675-1.5-1.5m9 0c0-.825-.675-1.5-1.5-1.5-2.25 0-3 3-3 3h3c.825 0 1.5-.675 1.5-1.5m3 1.5h-15v3h15z" }, null, -1),
    _createElementVNode("path", { d: "M10.825 13H14.5c1.8 0 2.25 1.5 2.25 1.5L8.8 17.35c-.6.15-1.275.15-1.875-.075L1 14.805V10.75h3c1.2 0 2.325.525 3 1.5h2.25c1.125 0 2.25 1.125 2.25 2.25H6.25" }, null, -1)
  ]))]))
}
export default { render: render }